<h2 mat-dialog-title>{{ 'explanation_manage_pages' | transloco }}</h2>
<mat-dialog-content>
    <div cdkDropList class="pages-list" (cdkDropListDropped)="drop($event)">
        @for (page of pages(); track $index; let i = $index) {
            <div class="page-item" cdkDrag cdkDragHandle>
                <mat-icon class="drag-handle">drag_indicator</mat-icon>
                <span class="page-preview">{{ getPagePreview(page) }}</span>
            </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="cancel()">{{ 'cancel' | transloco }}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{ 'ok' | transloco }}</button>
</mat-dialog-actions>
